export { DealerLabel } from './dealer-label';
